import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=14f445a0&scoped=true&"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetForm.vue?vue&type=style&index=0&id=14f445a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f445a0",
  null
  
)

export default component.exports